const schema = () => ({
  required: ["password"],
  type: "object",
  properties: {
    password: {
      type: "string",
      title: "رمز جدید",
      format: "password",
      minLength: 8,
    },
  },
});

export default schema;
